export default {
  install: (app, options) => {
    app.config.globalProperties.appConfig = options;
    app.provide("appConfig", options);
  },
};
